import { render, staticRenderFns } from "./SettingModule.vue?vue&type=template&id=cc2ad706"
import script from "./SettingModule.vue?vue&type=script&lang=js"
export * from "./SettingModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports